import { useParams } from "react-router-dom";
import { categories, articles, faqItems } from "@/mocks/data";
import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import ArticleCard from "@/components/base/ArticleCard";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <>
        <SEOHead title="分类未找到" description="" keywords="" />
        <div className="min-h-screen bg-background-50">
          <Navbar />
          <main className="pt-20 pb-16">
            <div className="max-w-7xl mx-auto px-4 md:px-6 text-center py-20">
              <h1 className="text-2xl font-heading font-semibold text-foreground-950">分类未找到</h1>
            </div>
          </main>
          <Footer />
        </div>
      </>
    );
  }

  const filteredFaq = slug === "faq-category" ? faqItems : [];

  const seoTitle = `${category.name} - 成人影院专业指南 | 私享观影指南`;
  const seoDesc = category.description;

  return (
    <>
      <SEOHead
        title={seoTitle}
        description={seoDesc}
        keywords={`成人影院,${category.name},私密观影,观影指南`}
        ogType="website"
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: category.name },
              ]}
            />

            <div className="mt-6 mb-10">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
                {category.name}
              </h1>
              <p className="mt-3 text-foreground-600 text-sm leading-relaxed max-w-2xl">
                {category.description}
              </p>
            </div>

            {slug === "faq-category" && filteredFaq.length > 0 ? (
              <div className="flex flex-col gap-3 max-w-3xl">
                {filteredFaq.map((item, index) => (
                  <div
                    key={index}
                    className="bg-background-50 border border-background-200/70 rounded-lg p-5"
                  >
                    <h3 className="text-base font-medium text-foreground-900 mb-2">
                      {item.question}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                ))}
              </div>
            ) : categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16 text-foreground-500 text-sm">
                暂无该分类的文章，敬请期待
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}